export default __webpack_public_path__ + "assets/icon-replacement-blue.7e090fb0.webp";